"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _iconsMoreVertical = require("../../resources/icons-more-vertical.svg");
var _iconsNodearrow = require("../../resources/icons-nodearrow.svg");
var _Paper = _interopRequireDefault(require("../layouts/Paper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgChartNode = exports["default"] = /*#__PURE__*/function (_Component) {
  function OrgChartNode(props) {
    var _this;
    _classCallCheck(this, OrgChartNode);
    _this = _callSuper(this, OrgChartNode, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(OrgChartNode, _Component);
  return _createClass(OrgChartNode, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        sx = _this$props.sx,
        height = _this$props.height,
        type = _this$props.type,
        focused = _this$props.focused,
        arrowhead = _this$props.arrowhead,
        wrapperChildren = _this$props.wrapperChildren,
        moreButton = _this$props.moreButton,
        inHighlightPath = _this$props.inHighlightPath,
        alignItems = _this$props.alignItems;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          cursor: "default"
        }
      }, wrapperChildren, arrowhead && /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "klayo-orgchart_node-arrowhead",
        sx: {
          position: "absolute",
          left: "50%",
          marginLeft: "-4px",
          top: "-10px",
          width: "8px",
          height: "10px",
          background: "#f8f8fe",
          display: "flex",
          justifyContent: "center",
          "& svg path": {
            fill: inHighlightPath ? "var(--neon-blue-nb-500)" : "var(--neon-blue-nb-100)"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_iconsNodearrow.ReactComponent, null)), moreButton && /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "klayo-button klayo-orgchart_node-morebutton",
        onClick: function onClick(e) {},
        sx: {
          position: "absolute",
          display: "flex",
          right: "8px",
          top: "8px",
          padding: "0",
          width: "32px",
          height: "32px",
          cursor: "pointer",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            background: "var(--neon-blue-nb-050)"
          },
          "&:active": {
            background: "var(--neon-blue-nb-100)"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_iconsMoreVertical.ReactComponent, null)), /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        className: "klayo-orgchart_node klayo-orgchart_node-" + type,
        padding: focused ? "14px" : "16px",
        borderWidth: focused ? 3 : 1,
        borderColor: focused ? "var(--neon-blue-nb-500)" : "var(--neon-blue-nb-100)",
        sx: _objectSpread({
          boxSizing: "border-box",
          fontSize: "14px",
          fontFamily: "Inter, sans-serif",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: alignItems,
          //transition: 'border-color, border-width 150ms ease',
          height: height
        }, sx)
      }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
        direction: "column",
        spacing: 2,
        alignItems: "center",
        sx: {
          width: "100%"
        }
      }, children)));
    }
  }]);
}(_react.Component);
_defineProperty(OrgChartNode, "defaultProps", {
  arrowhead: true,
  moreButton: false,
  alignItems: "start"
});